import { AtlasMaterial } from './AtlasMaterial'

export function createAtlasBuilder({ anisotropy, skyUniforms, registry }) {
  const worker = new Worker(window.ATLAS_BUILDER_WORKER_PATH)

  const material = new AtlasMaterial({
    anisotropy,
    skyUniforms,
  })

  worker.onmessage = e => {
    const msg = e.data
    if (msg.op === 'material') {
      material.update(msg.material)
    }
  }

  worker.onerror = err => {
    console.error(err)
    console.log('atlas builder worker error')
  }

  worker.postMessage({
    op: 'init',
    registry: registry.serialize(),
  })

  registry.on('change', change => {
    worker.postMessage({
      op: 'registry_change',
      change,
    })
  })

  return {
    material,
    // destroy ??
  }
}
